import { colors } from '../../colors';
var pagination = {
  activeColor: colors.tomatoRed,
  defaultColor: colors.ash
};
export default pagination;